export const OTP = "code";
export const OTP_FORM_ID = "OtpForm";
export const MFA_CODE_SENT = "mfa-code-sent";

export const accountRecoveryUserData = "account_recovery_user_data";

export const incorrectCodeErrorMessage =
  "Your code is incorrect. Please try again or request a new code.";
export const expiredCodeErrorMessage =
  "Your code has expired. Please request a new code.";
export const maxAttemptsErrorMessage =
  "This code is no longer valid due to too many failed attempts. Please request a new code.";
export const defaultErrorMessage = "Something went wrong. Please try again";

export const requiredMessage = "This field is required";
export const minLengthMessage = (codeLength) =>
  `Your code doesn't look right. Please check it has ${codeLength} digits.`;
export const newCodeMessage =
  "We've sent you a new code, please check your inbox.";
export const newCodeErrorMessage =
  "There has been an error sending the code. Please try again.";
